import { render, staticRenderFns } from "./NotificationNewUser.vue?vue&type=template&id=1e0a75d1&scoped=true&"
import script from "./NotificationNewUser.vue?vue&type=script&lang=ts&"
export * from "./NotificationNewUser.vue?vue&type=script&lang=ts&"
import style0 from "./NotificationNewUser.vue?vue&type=style&index=0&id=1e0a75d1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e0a75d1",
  null
  
)

export default component.exports